<div class="profile-page" fxLayout="column" fxLayoutGap="16px">

  <!-- Cabecalho -->
  <div class="page-header" fxLayout="row" fxLayoutAlign="space-between center">
    <h1 class="page-title">Meu Perfil</h1>
    <button mat-stroked-button (click)="back()">
      <mat-icon>arrow_back</mat-icon> Voltar
    </button>
  </div>

  <!-- SECAO 1: Identidade -->
  <mat-card class="profile-identity-card">
    <mat-card-content>
      <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" fxLayoutAlign="start center">

        <!-- Avatar -->
        <div class="avatar-wrapper" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="8px">
          <div class="avatar-container" (click)="editingProfile && avatarInput.click()">
            <img class="profile-avatar" [src]="getAvatarUrl()" alt="Foto do perfil" />
            <div class="avatar-overlay" *ngIf="editingProfile">
              <mat-icon>camera_alt</mat-icon>
              <span>Alterar foto</span>
            </div>
          </div>
          <input #avatarInput type="file" accept="image/*" style="display:none" (change)="onAvatarFileChange($event)" />
          <span class="avatar-hint" *ngIf="editingProfile">Clique na foto para alterar</span>
        </div>

        <!-- Info principal -->
        <div fxFlex fxLayout="column" fxLayoutGap="8px">
          <div class="identity-name">{{ data?.firstName }} {{ data?.lastName }}</div>
          <div class="identity-meta">
            <mat-icon class="meta-icon">alternate_email</mat-icon>
            <span>{{ data?.username }}</span>
          </div>
          <div class="identity-meta">
            <mat-icon class="meta-icon">email</mat-icon>
            <span>{{ data?.email }}</span>
          </div>

          <!-- Grupos (badges) -->
          <div fxLayout="row wrap" fxLayoutGap="6px" class="groups-row" *ngIf="getUserGroupNames().length > 0">
            <mat-chip-list>
              <mat-chip *ngFor="let g of getUserGroupNames()" class="group-chip" disabled>
                {{ g }}
              </mat-chip>
            </mat-chip-list>
          </div>

          <!-- Datas -->
          <div class="identity-dates" fxLayout="row" fxLayoutGap="16px">
            <span *ngIf="data?.createdAt">Criado em: {{ data?.createdAt | date:'dd/MM/yyyy' }}</span>
            <span *ngIf="data?.updatedAt">Atualizado em: {{ data?.updatedAt | date:'dd/MM/yyyy' }}</span>
          </div>
        </div>

      </div>
    </mat-card-content>
  </mat-card>

  <!-- SECAO 2: Dados Pessoais -->
  <mat-expansion-panel [expanded]="editingProfile" class="profile-section">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="section-icon">person</mat-icon>
        Dados Pessoais
      </mat-panel-title>
      <mat-panel-description *ngIf="!editingProfile">
        Clique para editar seus dados
      </mat-panel-description>
    </mat-expansion-panel-header>

    <form [formGroup]="profileForm" (ngSubmit)="saveProfile()">
      <div fxLayout="row wrap" fxLayoutGap="16px grid" class="form-fields">

        <mat-form-field fxFlex="50" fxFlex.lt-md="100" appearance="outline">
          <mat-label>Nome</mat-label>
          <input matInput formControlName="firstName" placeholder="Nome" />
          <mat-error *ngIf="profileForm.get('firstName')?.hasError('required')">Obrigatorio</mat-error>
          <mat-error *ngIf="profileForm.get('firstName')?.hasError('minlength')">Minimo 2 caracteres</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="50" fxFlex.lt-md="100" appearance="outline">
          <mat-label>Sobrenome</mat-label>
          <input matInput formControlName="lastName" placeholder="Sobrenome" />
          <mat-error *ngIf="profileForm.get('lastName')?.hasError('required')">Obrigatorio</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="50" fxFlex.lt-md="100" appearance="outline">
          <mat-label>E-mail</mat-label>
          <input matInput formControlName="email" type="email" placeholder="email@exemplo.com" />
          <mat-error *ngIf="profileForm.get('email')?.hasError('required')">Obrigatorio</mat-error>
          <mat-error *ngIf="profileForm.get('email')?.hasError('email')">E-mail invalido</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="50" fxFlex.lt-md="100" appearance="outline">
          <mat-label>Telefone / Celular</mat-label>
          <input matInput formControlName="phone" placeholder="(00) 00000-0000" />
        </mat-form-field>

        <mat-form-field fxFlex="50" fxFlex.lt-md="100" appearance="outline">
          <mat-label>CPF</mat-label>
          <input matInput formControlName="document" placeholder="000.000.000-00" />
        </mat-form-field>

      </div>

      <div class="section-actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" *ngIf="!editingProfile">
        <button type="button" mat-raised-button color="primary" (click)="startEditProfile()">
          <mat-icon>edit</mat-icon> Editar Dados
        </button>
      </div>

      <div class="section-actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px" *ngIf="editingProfile">
        <button type="submit" mat-raised-button color="primary" [disabled]="profileForm.invalid || savingProfile">
          <mat-spinner diameter="16" *ngIf="savingProfile" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!savingProfile">save</mat-icon>
          {{ savingProfile ? 'Salvando...' : 'Salvar' }}
        </button>
        <button type="button" mat-stroked-button (click)="cancelEditProfile()" [disabled]="savingProfile">
          Cancelar
        </button>
      </div>
    </form>
  </mat-expansion-panel>

  <!-- SECAO 3: Seguranca -->
  <mat-expansion-panel class="profile-section">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="section-icon">lock</mat-icon>
        Seguranca
      </mat-panel-title>
      <mat-panel-description>Alterar senha</mat-panel-description>
    </mat-expansion-panel-header>

    <form [formGroup]="passwordForm" (ngSubmit)="savePassword()">
      <div fxLayout="row wrap" fxLayoutGap="16px grid" class="form-fields">

        <mat-form-field fxFlex="100" fxFlex.gt-sm="33" appearance="outline">
          <mat-label>Senha atual</mat-label>
          <input matInput formControlName="password" type="password" placeholder="Senha atual" />
          <mat-error *ngIf="passwordForm.get('password')?.hasError('required')">Obrigatorio</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100" fxFlex.gt-sm="33" appearance="outline">
          <mat-label>Nova senha</mat-label>
          <input matInput formControlName="newPassword" type="password" placeholder="Nova senha" />
          <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('required')">Obrigatorio</mat-error>
          <mat-error *ngIf="passwordForm.get('newPassword')?.hasError('minlength')">Minimo 4 caracteres</mat-error>
        </mat-form-field>

        <mat-form-field fxFlex="100" fxFlex.gt-sm="33" appearance="outline">
          <mat-label>Confirmar nova senha</mat-label>
          <input matInput formControlName="confirmPassword" type="password" placeholder="Confirmar nova senha" />
          <mat-error *ngIf="passwordForm.get('confirmPassword')?.hasError('required')">Obrigatorio</mat-error>
        </mat-form-field>

      </div>

      <div class="section-actions" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
        <button type="submit" mat-raised-button color="accent" [disabled]="passwordForm.invalid || savingPassword">
          <mat-spinner diameter="16" *ngIf="savingPassword" class="btn-spinner"></mat-spinner>
          <mat-icon *ngIf="!savingPassword">lock_reset</mat-icon>
          {{ savingPassword ? 'Alterando...' : 'Alterar Senha' }}
        </button>
      </div>
    </form>
  </mat-expansion-panel>

  <!-- SECAO 4: Minhas Permissoes -->
  <mat-expansion-panel class="profile-section">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="section-icon">admin_panel_settings</mat-icon>
        Minhas Permissoes
      </mat-panel-title>
      <mat-panel-description>Visualizacao somente leitura</mat-panel-description>
    </mat-expansion-panel-header>

    <div class="permissions-container">
      <p class="permissions-info">
        <mat-icon class="info-icon">info</mat-icon>
        Estas sao as permissoes atribuidas ao seu perfil. Para altera-las, contate o administrador do sistema.
      </p>
      <app-permission-selector
        [permissions]="userPermissions"
        [catalog]="permissionGroups"
        [selectedIds]="userPermissionSelectedIds"
        [disabled]="true"
        [frontFirstGroups]="frontFirstGroups"
        [frontFirstLoading]="frontFirstLoading"
        [loading]="permissionsLoading">
      </app-permission-selector>
    </div>
  </mat-expansion-panel>

</div>
